import React from 'react';
import { Link } from 'react-router-dom';
import { useFetchTransfers } from '../../hooks/useFetchTransfers';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import LoadingSpinner from '../LoadingSpinner';


interface TeamTransfersProps {
  teamId: string;
  gameweek: number;
}

const TeamTransfers: React.FC<TeamTransfersProps> = ({ teamId, gameweek }) => {
  const { transfers, loading, playerData, currentGameweekTransferCost } = useFetchTransfers(String(gameweek), Number(teamId));

  return (

    <div className='mx-4 text-content'>
      <Link
        to="/pointsHit"
        className='flex min-h-11 justify-center items-center gap-2 underline mb-4 text-sm text-content-secondary hover:text-content transition-colors'
        state={{ gameweek }}
      >
        See which Managers took a point hit this week
        <ArrowRight size={16} className="text-accent" />
      </Link>
      <h2 className="text-2xl font-bold mb-4 text-center">Transfers</h2>

      {loading && <div className="flex justify-center items-center w-full h-full"><LoadingSpinner /></div>}


      {!loading && transfers.length === 0 && (
        <div className="text-center text-content-secondary">
          💤 No transfers made this week!
        </div>
      )}

      {!loading && transfers.length > 0 && (
        <div className="grid gap-4">
          {transfers.map((transfer, index) => (
            <div key={index} className="bg-surface text-content shadow ring-1 ring-line rounded-xl p-4 text-sm md:text-base flex items-center justify-between">
              <div className="flex items-center gap-2 justify-between w-full px-4 ">
                <div className='flex flex-row gap-2 items-center'>
                  <ArrowLeft size={18} className="text-red-600 dark:text-red-400 shrink-0" />
                  <span className="line-through text-content-secondary">{playerData[transfer.element_out]}</span>
                </div>
                <div className='flex flex-row gap-2 items-center'>
                  <span className="font-semibold">{playerData[transfer.element_in]}</span>
                  <ArrowRight size={18} className="text-green-700 dark:text-green-400 shrink-0" />
                </div>
              </div>
              <div className="text-xs text-content-muted">GW {transfer.event}</div>
            </div>
          ))}
          {currentGameweekTransferCost > 0 && (
            <div className="text-right text-sm text-red-600 dark:text-red-400">
              Transfer cost: -{currentGameweekTransferCost} pts
            </div>
          )}
        </div>
      )}


    </div>
  );
}


export default TeamTransfers;
